import { RetailerHeaderModel } from '../../../../app/services/api/ofdClient';
import { CreditSummary } from '../../../../app/services/api/generated';
import WeightedPointsMap from '../components/WeightedPointsMap';

interface CreditsClaimsByMarketProps {
  credits: CreditSummary[];
  retailers: RetailerHeaderModel[];
}

const CreditsClaimsByMarket = ({ credits, retailers }: CreditsClaimsByMarketProps) => {
  const heatmapData = credits
    .map(c => {
      const retailer = retailers.find(r => r.name === c.retailer);
      if (retailer?.latitude && retailer?.longitude) {
        return {
          location: { lat: retailer.latitude, lng: retailer.longitude },
          weight: c.value,
        };
      }
      return null;
    })
    .filter((h): h is { location: { lat: number; lng: number }; weight: number } => !!h);

  return <WeightedPointsMap points={heatmapData} />;
};

export default CreditsClaimsByMarket;
